import { useEffect, useState } from "react";
import { loadFormRegistry } from "../utils/formRegistryLoader";

export function useFormRegistry() {
  const [registry, setRegistry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    loadFormRegistry()
      .then((data) => {
        if (!cancelled) {
          setRegistry(data);
          setError(data ? null : new Error("Registry not loaded"));
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setRegistry(null);
          setError(err);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const localeCount = registry?.localeCounts
    ? Object.values(registry.localeCounts).reduce((a, b) => a + b, 0)
    : 0;

  return { registry, loading, error, localeCount };
}
